import React from "react";
import { X } from "lucide-react";

/**
 * Optional numeric cap input (Update 24, Change 2).
 * value: number | null  (null = unlimited → shows "—" placeholder)
 * - Clearable to blank (backspace) → null.
 * - 0 or blank → null (unlimited). Negatives clamp to 1. Minimum stored value = 1.
 * - A small × clear button appears to the right when a value is set.
 */
export default function OptionalCapInput({ value, onChange, testid, placeholder = "—", className = "" }) {
  const handle = (raw) => {
    if (raw === "") return onChange(null);
    let n = parseInt(raw, 10);
    if (isNaN(n) || n === 0) return onChange(null);
    if (n < 0) n = 1;
    onChange(n);
  };
  const hasValue = value !== null && value !== undefined && value !== "";
  return (
    <div className="relative">
      <input
        type="number" min="1"
        className={`st-input w-full ${hasValue ? "pr-8" : ""} ${className}`}
        value={hasValue ? value : ""}
        placeholder={placeholder}
        data-testid={testid}
        onChange={(e) => handle(e.target.value)}
      />
      {hasValue && (
        <button
          type="button"
          onClick={() => onChange(null)}
          className="absolute right-2 top-1/2 -translate-y-1/2 text-[#8a8a8a] hover:text-white"
          data-testid={testid ? `${testid}-clear` : undefined}
          title="Clear (unlimited)"
          aria-label="Clear (unlimited)"
        >
          <X size={14} />
        </button>
      )}
    </div>
  );
}
